// frontend-react/src/components/TwoFactorAuthModal.js (ΠΛΗΡΕΣ ΚΑΙ ΤΕΛΙΚΟ)

import React, { useState, useEffect } from 'react';
import * as api from '../api/api';
import toast from 'react-hot-toast';
import './StrategyModal.css'; 
import './TwoFactorAuthModal.css'; 
import { FiCopy } from 'react-icons/fi';

const TwoFactorAuthModal = ({ isOpen, onClose, onComplete }) => {
    const [view, setView] = useState('info'); 
    const [qrCode, setQrCode] = useState('');
    const [secret, setSecret] = useState('');
    const [recoveryCodes, setRecoveryCodes] = useState([]);
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);

    const handleGenerate = async () => {
        setLoading(true);
        try {
            const res = await api.generate2FASecret();
            setQrCode(res.data.qr_code);
            setSecret(res.data.secret);
            setView('enable');
        } catch (error) {
            toast.error('Failed to generate 2FA secret.');
            onClose();
        } finally {
            setLoading(false);
        }
    };

    const handleEnable = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.enable2FA({ code });
            setRecoveryCodes(res.data.recovery_codes);
            setView('recovery');
            toast.success('2FA enabled successfully!');
        } catch (error) {
            toast.error(error.response?.data?.detail || 'Failed to enable 2FA.');
        } finally {
            setLoading(false);
        }
    };
    
    const handleDisable = async (e) => {
        e.preventDefault();
        const promise = api.disable2FA({ code });
        toast.promise(promise, {
            loading: 'Verifying code and disabling 2FA...',
            success: () => {
                onComplete();
                onClose();
                return '2FA disabled successfully!';
            },
            error: (err) => err.response?.data?.detail || 'Failed to disable 2FA.',
        });
    };

    const handleFinish = () => {
        onComplete();
        onClose();
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("Codes copied to clipboard!");
    };

    useEffect(() => {
        if (!isOpen) {
            setTimeout(() => {
                setView('info');
                setQrCode('');
                setSecret('');
                setRecoveryCodes([]);
                setCode('');
            }, 300);
        }
    }, [isOpen]);

    if (!isOpen) return null;
    
    const renderContent = () => {
        switch (view) {
            case 'recovery':
                return (
                    <>
                        <h3>Save Your Recovery Codes!</h3>
                        <p>Store these codes in a safe place (e.g., a password manager). They are the ONLY way to access your account if you lose your device. Each code can be used once.</p>
                        <div className="recovery-codes-grid">
                            {recoveryCodes.map((c, i) => <span key={i} className="mono-font">{c}</span>)}
                        </div>
                        <button className="control-button" onClick={() => copyToClipboard(recoveryCodes.join('\n'))}><FiCopy/> Copy Codes</button>
                        <button className="control-button" onClick={handleFinish} style={{marginTop: '1rem', background: 'var(--positive)'}}>I have saved my codes</button>
                    </>
                );
            case 'enable':
                return (
                    <>
                        <h3>Scan QR Code</h3>
                        <p>Scan the image below with your authenticator app (e.g., Google Authenticator, Authy).</p>
                        <div className="qr-code-container">
                            {qrCode && <img src={qrCode} alt="Authenticator setup QR code" width="200" height="200" />}
                        </div>
                        <p className="manual-code">Or enter this code manually: <strong className="mono-font">{secret}</strong></p>
                        <form onSubmit={handleEnable}>
                            <div className="form-group">
                                <label>Enter the 6-digit code from your app to verify:</label>
                                <input type="text" value={code} onChange={e => setCode(e.target.value)} required minLength="6" maxLength="6" placeholder="123456" />
                            </div>
                            <button type="submit" className="control-button" disabled={loading}>{loading ? 'Verifying...' : 'Verify & Enable'}</button>
                        </form>
                    </>
                );
            case 'disable':
                return (
                     <>
                        <h3>Disable Two-Factor Authentication</h3>
                        <p>To disable 2FA, please enter a code from your authenticator app.</p>
                        <form onSubmit={handleDisable}>
                            <div className="form-group">
                                <label>Enter the 6-digit code:</label>
                                <input type="text" value={code} onChange={e => setCode(e.target.value)} required minLength="6" maxLength="6" placeholder="123456" />
                            </div>
                            <button type="submit" className="control-button danger">Confirm & Disable</button>
                        </form>
                    </>
                );
            default: // 'info' view
                return (
                    <>
                        <h3>Setup Two-Factor Authentication</h3>
                        <p>Enhance your account's security by requiring a second verification step when you log in.</p>
                        <button className="control-button" onClick={handleGenerate} disabled={loading}>
                            {loading ? 'Please wait...' : 'Start 2FA Setup'}
                        </button>
                        <hr style={{borderColor: 'var(--border-primary)', margin: '1.5rem 0'}}/>
                        <p style={{color: 'var(--text-secondary)'}}>Already have 2FA enabled?</p>
                        <button className="control-button" style={{background: 'var(--background-tertiary)', color: 'var(--text-secondary)'}} onClick={() => setView('disable')}>Disable 2FA</button>
                    </>
                );
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{maxWidth: '500px'}}>
                 <div className="modal-header">
                    <h2>Security Settings</h2>
                    <button onClick={onClose} className="close-button">&times;</button>
                </div>
                <div className="modal-body">
                   {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default TwoFactorAuthModal;